import React, {useEffect} from 'react';
import CardsContent from "./cards-content.jsx";
import HorizontalBarsContent from "./horizontal-bars-content.jsx";
import GraphicsContent from "./graphics-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";

const ReportContent = ({ data, collapsed }) => {

    useEffect(() => {
        if (!data) return;

        const cards = Object.fromEntries((data?.cards ?? []).map(({ label, value }) => [label, value]));

        if (cards) {
            let values = [
                ["Total de solicitações", cards?.total_solicitations ?? 0],
                ["Solicitações pendentes", cards?.solicitations_pendings ?? 0],
                ["Duração média da solicitação", cards?.avg_duration ?? '0s'],
            ];

            if (values) ReportUtils.createExportableTable(["Descrição", "Quantidade"], values, "Cards");
        }

        const createExport = (list, title, customHeaders = null) => {
            if (!list?.length) return;

            ReportUtils.createExportableTable(list.map(item => item.label), list.map(item => item.value), title, null, customHeaders);
        };

        const createLineExport = (series, title) => {
            const sorted = [...new Set(series.flatMap(s => s.data.map(i => i.label)))].sort((a, b) => {
                const [dayA, monthA, yearA] = a.split("/").map(Number);
                const [dayB, monthB, yearB] = b.split("/").map(Number);

                return new Date(yearA, monthA - 1, dayA) - new Date(yearB, monthB - 1, dayB);
            });

            const values = sorted.map(date => [
                date,
                ...series.map(s => Number(s.data.find(i => i.label === date)?.value ?? 0))
            ]);

            ReportUtils.createExportableTable(["Data", ...series.map(s => s.name)], values, title);
        };

        createExport(data?.status, "Status", ["Status", "Quantidade"]);
        createExport(data?.description, "Descrição da solicitação");
        createExport(data?.user_observation, "Observação do agente");
        createExport(data?.attaches, "Anexos");

        createExport(data?.created_by, "Cadastrado por", ["Agente", "Quantidade"]);
        createLineExport([
            { name: "Data do fato", data: data?.incident_timeline ?? [] },
            { name: "Criação da solicitação", data: data?.solicitation_timeline ?? [] },
            { name: "Finalização da solicitação", data: data?.finalized_timeline ?? [] },
        ], "Ciclo de vida das solicitações");
        createExport(data?.applicant, "Solicitantes", ["Solicitante", "Quantidade"]);
        createExport(data?.organization, "Organizações", ["Organização", "Quantidade"]);
        createExport(data?.reason, "Naturezas", ["Natureza", "Quantidade"]);
        createExport(data?.operation_group, "Grupos de operação", ["Grupo", "Quantidade"]);

    }, [data]);

    return (
        <>

            <CardsContent key={`cards-${collapsed}`} data={data}/>

            <HorizontalBarsContent key={`horizontal-bars-${collapsed}`} data={data}/>

            <GraphicsContent key={`graphics-${collapsed}`} data={data}/>

            <div id="chart-tables"/>

        </>
    );
};

export default ReportContent;